import { useTranslation } from 'react-i18next'

type SupportAssistanceProps = {
  'data-testid'?: string
}

export const SupportAssistance = ({ 'data-testid': dataTestId = 'support-assistance' }: SupportAssistanceProps) => {
  const { t } = useTranslation()

  return (
    <div
      data-testid={dataTestId}
      className='text-character-secondary mt-6 text-center font-medium'
    >
      <p>{t('need_assistance')}</p>
      <p className='mt-2'>
        {t('reach_out_at')}{' '}
        <a
          className='text-character-secondary! !underline'
          href='mailto:support@taptelehealth.com'
        >
          support@taptelehealth.com
        </a>
      </p>
    </div>
  )
}
